import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgViewBig = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 48 48",
	...props,
	children: /* @__PURE__ */ _jsx("switch", { children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", { d: "M5.625 27.062h15.312v15.312H5.625zm21.437 0h15.312v15.312H27.062zM5.625 5.625h15.312v15.312H5.625zm21.437 0h15.312v15.312H27.062z" }) }) })
});
export default SvgViewBig;
